import React, { Component } from "react";
import {
  getAnswers,
  updateQuestionAnswers,
} from "../../../../services/formService";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';

class TypeVideo extends Component {
  state = {
    Question_ID: this.props.Question_ID,
    Question_Answers: [{ Answer_ID: 0, Answer_Text: "" }],
  };

  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
  }

  async componentDidMount() {
    let { data: Question_Answers } = await getAnswers(this.state.Question_ID);
    if (Question_Answers.length === 0) {
      Question_Answers = [{ Answer_ID: 0, Answer_Text: "" }];
    }
    this.setState({ Question_Answers });
  }

  async handleSave() {
    const Question_ID = await this.props.onSave(this.state.Question_Answers);
    this.setState({ Question_ID });

    // const { data } = await updateQuestionAnswers(
    //   Question_ID,
    //   this.state.Question_Answers
    // );

    // if (data.includes("Error")) {
    //   toaster('error', data);
    // } else {
    //   toaster('success', 'Saved.');
    //   this.setState({ Question_Answers: data });
    // }
  }

  handleRemove() {
    this.props.onRemove();
  }

  handldAnswerChange = (text, index) => {
    const Question_Answers = [...this.state.Question_Answers];
    Question_Answers[index]["Answer_Text"] = text;
    this.setState({ Question_Answers });
  };

  render() {
    let { Question_Answers } = this.state;
    return (
      <React.Fragment>
        <div className="form-group">
          <label htmlFor="video_link">Please Enter the link of the video</label>
          <input
            type="text"
            className="form-control"
            value={Question_Answers[0].Answer_Text}
            onChange={(event) => this.handldAnswerChange(event.target.value, 0)}
          />
        </div>

        <div className="float-right">
          <button
            className="btn btn-outline-primary m-2"
            onClick={this.handleSave}
          >
            Save
          </button>
          <button
            className="btn btn-outline-danger"
            onClick={this.handleRemove}
          >
            Delete
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default TypeVideo;
